import { bytesToNDigits } from '@mail/cross-sizes-utils';
import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_BIZ_USER, IS_CORP_USER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';
import { registerExperiment } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';

type PriorityDownloadAB = 'a' | 'b' | 'c' | false;

interface PriorityDownloadTariffs {
    title: string;
    tariffsNumber: string;
    activeTab: string;
}

const priorityDownloadAB: PriorityDownloadAB = !IS_BIZ_USER && !IS_CORP_USER && !IS_WEBVIEW && getFeature('priority-download-ab');

const priorityDownloadFileSize = (getFeature('priority-download-file-size-mb') || 1024) * 1024 * 1024;

const priorityDownloadFilesInPack = getFeature('priority-download-files-in-pack') || 2;

const priorityDownloadDelaySec = getFeature('priority-download-delay-sec') || 20;

const priorityDownloadTariffsInfo: PriorityDownloadTariffs = getFeature('priority-download-tariffs') || {};

export const priorityDownload = {
    paySource: 'popup_download_bigfiles',
    enabled: !!priorityDownloadAB && priorityDownloadAB !== 'a',
    filesInPackLimit: priorityDownloadFilesInPack,
    fileSizeLimit: bytesToNDigits(priorityDownloadFileSize, 3),
    delaySec: priorityDownloadDelaySec,
    buyTitle: priorityDownloadTariffsInfo.title || 'Отключение рекламы и\u00A0другие опции с\u00A0подпиской Mail Space',
    tariffsNumber: priorityDownloadTariffsInfo.tariffsNumber || '13',
    activeTab: priorityDownloadTariffsInfo.activeTab || 'y',
} as const;

registerExperiment(
    'priority-download',
    priorityDownloadAB,
    [AnalyticEventNames.PRIORITY_DOWNLOAD_SHOW, AnalyticEventNames.PRIORITY_DOWNLOAD_CLICK, AnalyticEventNames.TARIFF_BUY],
    {
        mapEventNames: {
            PRIORITY_DOWNLOAD_CLICK: 'click',
            PRIORITY_DOWNLOAD_SHOW: 'show',
        },
        sendXrayArgs: {
            TARIFF_BUY: ({ paySource }, { eventName }) => ({
                eventName: paySource?.includes(priorityDownload.paySource) ? 'prtdwnld' : eventName,
            }),
        },
    }
);
